import { imageTitle } from './ImageStore';

export const updateImageTitle = (value) => imageTitle.update((oldValue) => value);
